import React from 'react';
import fr from 'facet-rest';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import PrimaryActionLinkButton from 'Components/ComponentLibrary/Organisms/PrimaryActionLinkButton';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import ScheduleMeetingInChiliPiperButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingScheduleMeeting/PrimaryActionButtonPicker/ScheduleMeetingInChiliPiperButton';
import { pick } from 'Helpers/Affordances';
import ScheduleMeetingButton from './ScheduleMeetingButton';
import UpcomingMeetingButton from './UpcomingMeetingButton';

const MeetingInformationButtonPicker = (props) => {
  const { clientDashboardResource } = useDashboardContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { refreshClientDashboardResource } = useDashboardContext();

  return pick(clientDashboardResource, {
    [fr.relationships.waitlistScheduleChiliPiperMeeting.name]:
  <PrimaryActionLinkButton
    relationship={clientDashboardResource.relationship(fr.relationships.waitlistScheduleChiliPiperMeeting.name)}
    onClick={() => {
      logStandardizedEvent(categories.clientDashboard, eventTypes.clickButton, 'schedule outreach with mx');
    }}
  />,
    [fr.relationships.scheduleMeetingWithPlanner.name]: <ScheduleMeetingButton scheduleRelationship={clientDashboardResource.relationship(fr.relationships.scheduleMeetingWithPlanner.name)} {...props} />,
    [fr.relationships.scheduleMeetingWithMx.name]:
  <ScheduleMeetingInChiliPiperButton resource={clientDashboardResource} isPrimary={false} onRedirect={() => refreshClientDashboardResource()} scheduleChiliPiperMeetingRelationship={clientDashboardResource.relationship(fr.relationships.scheduleMeetingWithMx.name)} />,
    [fr.relationships.scheduleMeetingWithConcierge.name]:
  <ScheduleMeetingInChiliPiperButton resource={clientDashboardResource} isPrimary={false} onRedirect={() => refreshClientDashboardResource()} scheduleChiliPiperMeetingRelationship={clientDashboardResource.relationship(fr.relationships.scheduleMeetingWithConcierge.name)} />,
    [fr.relationships.upcomingMeeting.name]: <UpcomingMeetingButton {...props} />,
  }, null);
};

export default MeetingInformationButtonPicker;
